import { Chip } from "@mui/material";
import { FormStatus, FormStatusColors } from "./formStatusIcon";

export default function FormStatusChip({ status }: { status: FormStatus }) {
  return <Chip label={status} color={FormStatusColors[status]} />;
}
